(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .factory('TestPlan', TestPlan);

    TestPlan.$inject = ['$resource'];

    function TestPlan($resource) {
        return $resource('api/test-plans/monitoring/:storageKey', { storageKey: '@storageKey' }, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'detail': {
                method: 'GET'
            },
            'hide': {
                method: 'DELETE'
            },
            'deletePlan': {
                method: 'DELETE',
                url: 'api/test-plans/monitoring/:storageKey/permanent'
            },
            'assignableUsers': {
                method: 'GET',
                url: 'api/test-plans/users',
                isArray: true
            },
            'upload': {
                method: 'POST',
                url: 'api/test-plans/upload',
                transformRequest: angular.identity,
                headers: {
                    'Content-Type': undefined
                }
            },
            'myPlans': {
                method: 'GET',
                url: 'api/test-plans/my',
                isArray: true
            },
            'myPlan': {
                method: 'GET',
                url: 'api/test-plans/my/:storageKey'
            },
            'saveMyPlan': {
                method: 'PUT',
                url: 'api/test-plans/my/:storageKey'
            }
        });
    }
})();
